import React, { Component } from 'react';

export default class Chapter1 extends Component {
  render() {
    return (
      <div>
        <div className="medium-padding joysetter-header">
          <h6 className="white">Jet Lag Tool Kit</h6>
          <h1 className="white">Chapter 14: Learning to Listen</h1>
          <p className="white"><b>How to keep up hope in a seemingly hopeless world</b></p>
        </div>
        <div className="toolkit-content">
          <ol >
            <li>Be aware of what you are exposing your mind to and the amount of negativity you are subconsciously welcoming into your life through social media, news, websites, podcasts, radio, articles, etc. Set a cap on the amount of time you allow yourself to be exposed to the non-stop flow of news outlets (the majority of which tend to be negative).
            </li>
            <li>Invest all of that awesome time you saved from limiting your exposure to negative news in positivity and empowerment through podcasts, books, and articles that are uplifting and educational. Focus on the positivity.
            </li>
            <li>Be the change you want to see in the world. Lead by example. Remember that small actions can have huge impacts.
            </li>
            <li>Give yourself at least five minutes a day to just be. Focus on your breath, do a guided meditation, whatever. Just do nothing but attempt to clear your head for at least five minutes a day.
            </li>
            <li>Try to listen to the inner wisdom and intuition that is inside of you. It is there. By consistently following the above steps you will create room for it to speak up. The more you listen, the more clearly it will speak and be heard.
            </li>
          </ol>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/toolkits/chapter14.js